import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { IUserContext } from '../store/state/IUserContext';
import * as fromStore from '../store/reducers';

@Injectable()
export class CurrentUserService {
  userContext: IUserContext;
  private currentSessionToken: string;

  constructor(private store: Store<IUserContext>) {
    this.store.select(fromStore.getUserContext)
      .subscribe(uc =>
        this.userContext = uc
      );
  }

  private checkPermissions(permissions: string[]): boolean {
    for (let index in permissions) {
      if (this.hasPermission(permissions[index])) {
        return true;
      }
    }
    return false;
  }

  public getSessionToken(): string {
    return this.currentSessionToken;
  }

  public setSessionToken(sessionToken: string): void {
    this.currentSessionToken = sessionToken;
  }

  public hasPermission(permission: string | string[]): boolean {
    if (permission instanceof Array) {
      return this.checkPermissions(permission);
    }
    if (!this.userContext.userPermissions || !this.userContext.permissionsLoaded) {
      return false;
    }
    return this.userContext.userPermissions.indexOf(permission) >= 0;
  }

  public checkPermissionsLoaded(): boolean {
    return this.userContext.permissionsLoaded;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/services/CurrentUserService.ts